import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class Utils {
    constructor(
    ) {

    }

    preloadImagesList: any[] = null;;
    preloadImages(array, waitForOtherResources, timeout = null) {
        if (!this.preloadImagesList) {
            this.preloadImagesList = [];
        }
        var loaded = false, list = this.preloadImagesList, imgs = array.slice(0), t = timeout || 15 * 1000, timer;
        if (!waitForOtherResources || document.readyState === 'complete') {
            loadNow();
        } else {
            window.addEventListener("load", function () {
                clearTimeout(timer);
                loadNow();
            });
            // in case window.addEventListener doesn't get called (sometimes some resource gets stuck)
            // then preload the images anyway after some timeout time
            timer = setTimeout(loadNow, t);
        }

        function loadNow() {
            if (!loaded) {
                loaded = true;
                for (var i = 0; i < imgs.length; i++) {
                    var img = new Image();
                    img.onload = img.onerror = img.onabort = function () {
                        var index = list.indexOf(this);
                        if (index !== -1) {
                            // remove image from the array once it's loaded
                            // for memory consumption reasons
                            list.splice(index, 1);
                        }
                    }
                    list.push(img);
                    img.src = imgs[i];
                }
            }
        }
    }

    guid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0,
                v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    sleep(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    randomIntBetween(min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min);
    }

    //delete empty props
    clean(obj) {
        for (var propName in obj) {
            if (obj[propName] === null || obj[propName] === undefined) {
                delete obj[propName];
            }
        }
    }

    reverseString(str) {
        var newString = "";
        for (var i = str.length - 1; i >= 0; i--) {
            newString += str[i];
        }
        return newString;
    }

    mobileCheck() {
        let check = false;
        (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor);

        if (!check)
            if (window.innerWidth <= 600)
                check = true;

        return check;
    };

    getQueryParamByName(name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    getProjectIdFromTokenId(tokenId) {

        tokenId = tokenId.toString();

        //convert to string and reverse
        var reversed = this.reverseString(tokenId);
        //chop off reversed project id from end, reverse back
        return this.reverseString(reversed
            .substring(6, reversed.length));

    }

    getStringFragment(text, fragStart, fragEnd) {
        var r = new RegExp(fragStart + "(.)" + fragEnd, "gmi");
        var result = text.match(r);
        return result;
    }

    cleanseDescription(desc){

        var h = this.getStringFragment(desc, "#height\\[", "\\]");
        var w = this.getStringFragment(desc, "#width\\[", "\\]");
        // var url = this.getStringFragment(desc, "#gatewayurl\\[ ", " \\]");

        desc = desc
        .replace("#screenshot", "")
        .replace("#noscreenshot", "")
        .replace("#tokenid", "")
        .replace("#gatewayurl[https://arweave.net/5lIzSbZCqjM3JDNqWIMIo-Cjw6XuHshKe6-CMr70mqM]", "");

        if(h)
            desc = desc.replace(h[0], "");
        if(w)
            desc = desc.replace(w[0], "");
        // if(url)
        //     desc = desc.replace(url[0], "");

        return desc;
    }

}


